// extracted by mini-css-extract-plugin
export default {"BetterRXCardsContainer":"POqDwq4W","BetterRXCardsItemsWrapper":"PfsFahwV","BetterRXCardsItems":"cxO7VQjc","BetterRXCardsText":"wMn48CDA"};